import {Component, forwardRef, OnInit, ViewChild} from "@angular/core";
import {DetailService} from "../../../../services/details/detail.service";
import {ReloadComponent} from "../reload/reload.component";
import {Field} from "../field";
import {map} from "rxjs/operators";
import {ContentsHelper} from "../../../../helpers/contents.helper";

@Component({
	selector: "tig-select", template: `
        <div
            class="dynamic-field form-group"
            [class.has-error]="OBJ_select?.invalid">
            <label class="col-lg-3 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
                <i *ngIf="getHint()" class="fa fa-info-circle"
                   tooltip="{{getHint()|translate}}"
                   placement="top"
                   triggers="click"
                   containerClass="tig-tooltip"
                   delay="50"></i>
                <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
            <div class="col-lg-8">
                <select #OBJ_select="ngModel"
                        class="form-control"
                        name="OBJ_field_config.name"
                        [(ngModel)]="OBJ_data.id"
                        [required]="isRequired()">
                    <option value="">{{"please_select"|translate}}</option>
                    <option *ngFor="let OBJ_option of ARR_options" value="{{OBJ_option.id}}">
                        {{OBJ_option?.title}}
                    </option>
                </select>
                <div *ngIf="OBJ_select?.invalid">
                    {{'oError.sRequired'|translate}}
                </div>
            </div>
        </div>
    `, // get all components that extend relaodcomponent as viewChildren - see https://github.com/angular/angular/issues/8580
	providers: [{
		provide: ReloadComponent,
		useExisting: forwardRef(() => SelectComponent)
	},{
		provide: Field, useExisting: forwardRef(() => SelectComponent)
	}]
})
export class SelectComponent extends ReloadComponent implements OnInit {


	ARR_options = [];
	@ViewChild('OBJ_select', {static: false}) OBJ_select;


	/**
	 * Function > constructor
	 * @param OBJ_detail_service
	 */
	constructor(protected OBJ_detail_service: DetailService) {
		super(OBJ_detail_service);
	} // end function constructor


	/**
	 * Function > ngOnInit
	 */
	ngOnInit(): void {
		// this item has external options
		if (DetailService.externalOptions(this.OBJ_field_config)) {
			// tell the item how to reload and handle the options - the form itsself will later subscribe and check if all went well
			this.OBJ_observable_external_data = this.createObservable();
		} // end if
	} // end function ngOnInit


	/**
	 * Function > getLabelName
	 * @return {string}
	 */
	getLabelName(): string {
		return (this.OBJ_field_config.label || this.OBJ_field_config.name.toLocaleLowerCase());
	} // end Function getLabelName

	/**
	 * Function > isRequired
	 */
	isRequired() {
		if (this.OBJ_field_config.validators) {
			for (let OBJ_validator of this.OBJ_field_config.validators) {
				if (OBJ_validator.type === 'required') {
					return true;
				} // end if
			} // end for
		} // end if
		return false;
	} // end function isRequired

	/**
	 * Function > isInvalid
	 * @return {boolean}
	 */
	isInvalid(): boolean {
		return this.OBJ_select.invalid;
	} // end function isInvalid


	/**
	 * Function > createObservable
	 */
	createObservable() {
		return this.OBJ_detail_service.getHelper(this.OBJ_field_config._links.options.href, null, 'DatatableSelectComponent')
			.pipe(map((OBJ_contents_helper: ContentsHelper) => {
				this.ARR_options = OBJ_contents_helper.getListingData();
			}));
	} // end function createObservable


} // end class SelectComponent
